var exports = {
  "i": "xa15a2ab7--d795bd--wrapper",
};

module.exports = exports;
